import React, { useEffect, useRef, useState } from 'react';

import {Tabs, Tab, Box} from '@mui/material';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>{children}</Box>
            )}
        </div>
    );
}

const DefaultTabsComponent = ({tabs}) => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    }

    return(
        <>
            <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons={false}
                sx={{
                    '& .Mui-selected': {
                        color: "#3333cf",
                        bgcolor: "rgba(51, 51, 207, 0.1)",
                    },
                    '& .MuiTab-root': {
                        textTransform: 'capitalize', // Capitalize label text
                    },
                    '& .MuiTabs-indicator': {
                        backgroundColor: '#3333cf',
                    },
                    '& .MuiTouchRipple-root': {
                        color: '#3333cf',
                    },
                }}
                aria-label="scrollable prevent tabs example"
                >
                {
                    tabs.map((item) => (
                        <Tab label={item.label} />
                    ))
                }
            </Tabs>
            <br />
            {
                tabs.map((item, index) => (
                    <TabPanel key={index} value={value} index={index}>
                        {item.component}
                    </TabPanel>
                ))
            }
        </>
    )
}

export default DefaultTabsComponent